import React, { Fragment, useMemo } from 'react';
import { Button, Col, Row, Table, Tag } from 'antd';
import { currencyVND } from '../../../../utils';

export default (props) => {

	const { purchaseDetail } = props;
	const productList = purchaseDetail.orderProductResponse || [];

	const InfoRow = ({ label, value }) => (
		<Row style={{ marginBottom: 8 }}>
			<Col span={2} >{label}</Col>
			<Col span={22}>: {value || '---'}</Col>
		</Row>
	);

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			key: 'index',
			width: 60,
			render: (text, record, index) => index + 1
		},
		{
			title: 'Tên sản phẩm',
			dataIndex: 'productName',
			key: 'productName',
			width: 300,
			render: (text, record) => {
				return <Fragment><Row>
					<Col>
						<b>{text}</b>
					</Col>
				</Row>
					<Row gutter={12} style={{ marginTop: 10 }}>
						<Col>
							<Button type="dashed" onClick={() => {
								window.open(`/product/${record.productId}`);
							}}>{record.code}</Button>
						</Col>
					</Row>
				</Fragment>;
			}
		},
		{
			title: 'Phân Loại',
			dataIndex: 'isNormal',
			key: 'isNormal',
			align: 'center',
			width: 100,
			render: (isNormal) => {
				return isNormal ? <Tag style={{width: '110px'}} color="magenta">Sản phẩm thường</Tag> : <Tag style={{width: '110px'}} color="green">Serial/IMEI</Tag>;
			}
		},
		{
			title: 'Đơn vị',
			dataIndex: 'unitName',
			key: 'unitName',
			align: 'center',
			width: 150
		},
		{
			title: 'SL nhập',
			width: 150,
			dataIndex: 'quantity',
			align: 'center'
		},
		{
			title: 'Đơn giá',
			dataIndex: 'price',
			width: 150,
			align: 'center',
			render: (value) => currencyVND(value)
		},
		{
			title: 'Chiết khấu',
			dataIndex: 'discount',
			key: 'discount',
			width: 150,
			align: 'center',
			render: (value) => currencyVND(value)
		},
		{
			title: 'Thành tiền',
			width: 150,
			align: 'center',
			render: (record) => {
				return <>{`${currencyVND(((record.quantity || 1) * (record.price || 0)) - (record.discount > 0 ? record.discount * record.quantity : 0))}`}</>;
			}
		}
	];

	const expandedRowRender = (record) => {
		return <Fragment>
			<div style={{ marginLeft: '60px' }}>
				<div className={'mt-20 mb-20'}>
					<i>Danh sách IMEI ({record?.imeiList?.length || 0}): </i>{record?.imeiList.map((el) => <Tag style={{marginBottom: '5px'}} color={'blue'} key={el.id}>
					{el.imei}
				</Tag>)}
				</div>
			</div>
		</Fragment>;
	};

	const sum = useMemo(() => {
		let totalQuantity = 0;
		productList.forEach((el, idx) => {
			if (el.isNormal) {
				totalQuantity += el.quantity || 1;
			} else {
				const qtt = el?.imeiList.filter(el => el.status === 0).length || 0;
				totalQuantity += qtt;
			}
		});
		return {
			totalQuantity
		}
	}, [productList]);

	const renderFooter = () => {
		const s = sum;
		return <Fragment>
			<InfoRow label={'Số lượng'} value={productList.length > 0 ? s.totalQuantity : '---'} />
			{/*<InfoRow label={'Chiết khấu'} value={productList.length > 0 ? currencyVND(purchaseDetail.discount) : '---'} />*/}
			<b><InfoRow label={'Tổng tiền'} value={productList.length > 0 ? currencyVND(purchaseDetail.orderPrice) : '---'} /></b>
			{/*<InfoRow label={<b>Tiền cần trả</b>}*/}
			{/*				 value={<b style={{color: 'red'}}>{productList.length > 0 ? currencyVND(purchaseDetail.orderPrice) : '---'} </b>} />*/}
		</Fragment>;
	};

	const getExpandedRowKeys = () => {
		return productList.filter(el => !el.isNormal).map(el => el.id);
	};

	return (
		<Fragment>
			{/*<Card title={<Fragment><Icon type="inbox" /> Thông tin sản phẩm</Fragment>} className={'mt-20'}>*/}
				<Row gutter={12}>
					<Col>
						<Table
							rowKey={'id'}
							dataSource={productList}
							columns={columns}
							rowClassName="editable-row"
							pagination={false}
							expandIconAsCell={false}
							expandedRowRender={expandedRowRender}
							expandedRowKeys={getExpandedRowKeys()}
							expandIcon={() => ''}
						/>
					</Col>
					<Col className={'mt-20'}>
						{renderFooter()}
					</Col>
				</Row>
			{/*</Card>*/}
		</Fragment>
	);
};
